<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách thiết bị"
          v-model="table.searchText"
        ></v-text-field>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td>
              <span v-if="!props.item.isValid" class="red-text">{{ props.item.deviceImei }}</span>
              <span v-else>{{ props.item.deviceImei }}</span>
            </td>
            <td>{{ props.item.deviceType }}</td>
            <td>{{ props.item.planCode }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'IMEI',
            value: 'imei'
          },
          {
            text: 'Loại thiết bị',
            value: 'deviceType'
          },
          {
            text: 'Gói cước',
            value: 'planCode'
          }
        ]
      }
    };
  }
};
</script>
<style>
.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/device/components/exportlist.vue